<template>
  <view>
    <view class="warp" wx:style="{{warpStyle2}}">
      <block wx:if="{{!error}}">
        <text class="rule" wx:style="{{ruleStyle}}" bindtap="gotoLink(pageConfig.rule.link)">规则</text>
        <red-packet-close
          wx:if="{{activityCouponInfo}}"
          config="{{redPacketConfig}}"
          couponInfo="{{activityCouponInfo}}"
          btnText="{{btnText}}"
          packetType="launch-app"
          bind:click="toApp"
          bind:launchApp="toApp"
        />
        <res-banner wx:if="{{activityCouponInfo}}" template="{{info.template}}" />
      </block>
      <error-view wx:else error="{{error}}" message="{{errmsg}}" />
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import store from '../../lib/store'
import couponMixin from '../../lib/mixin/coupon-v3'
import { getStyle } from '../../lib/editor/utils'

import {
  utils,
  // eslint-disable-next-line
  trackEvent,
  build,
  xenv,
  is,
  launchApp
} from '@didi/webx-js'
createComponent({
  properties,
  mixins: [ couponMixin ],
  data: {
    style: {},
    redPacketConfig: {},
  },
  attached() {
    this.formatPageConfig && this.formatPageConfig()
    const isFriday = [ 5,6,0 ].includes(new Date().getDay())
    const showLaunchAppFriday = (process.env.MODE === 'editor' && this.pageConfig.launchApp.friday?.mockEnable) || (isFriday && this.pageConfig.launchApp.friday.enable)
    if (this.pageConfig.launchApp?.index?.style) {
      this.pageConfig.launchApp.index.style.backgroundImage ||= this.style.backgroundImage
      this.style = showLaunchAppFriday ? this.pageConfig.launchApp.friday.style : this.pageConfig.launchApp.index.style
    }
  },
  computed: {
    ...store.mapGetters([ 'initData' ]),
    warpStyle2() {
      if (this.error) {
        return {
          ...getStyle(this.style),
          backgroundImage: undefined,
        }
      }
      return getStyle(this.style)
    },
    btnText() {
      return this.pageConfig.launchApp?.button.text || this.pageConfig.index.button.text
    },
  },
  methods: {
    formatPageConfig() {
      // 理论上此组件都是新活动，不需要该逻辑兜底，可以考虑删除
      this.pageConfig.redPacket.style = this.pageConfig.redPacket.style2
      this.redPacketConfig = this.pageConfig.redPacket
      this.style = this.pageConfig.index.style
      if (!this.pageConfig.redPacket.style || !this.pageConfig.redPacket.style.marginTop) {
        this.redPacketConfig.style = {
          marginTop: 380,
        }
      }
      if (!this.pageConfig.index.style.backgroundImage) {
        this.style.backgroundImage = utils.webpUrl('https://ut-static.udache.com/webx/ut/nSqi0nEtIckBw3GBYHDp4.png')
      }
    },
    toApp: utils.debounce(
      function() {
        // this.gotoLink(this.initData.activity_info.app_link)
        const { x_act_key, id: xid } = this.initData.activity_info
        const commonParams = {
          xid,
          x_act_key,
        }
        const appLink = build(this.initData.activity_info.app_link, commonParams)
        const biz_referrer = xenv() === 'weixin' ? 'dunion_wechat_h5' : 'dunion_h5'
        const guidePageUrl = build(appLink, { biz_referrer })
        const splitUrl = appLink.split('/')
        const key = splitUrl[splitUrl.length - 1]
        const dchn = key && key.indexOf('?') ? key.split('?')[0] : key
        const launchAppParams = {
          launchAppDchn: dchn,
          // env: 'online',
          invokePriority: 'app',
          morePriority: [ 'app', 'download' ],
          isAutoInvokeApp: true,
          isCopyCmd: !is('ios'),
          cmdParams: {
            dsi: this.query.dsi,
            source_id: this.query.source_id,
            dunion_callback: this.query.dunion_callback,
          },
          extra: {
            guidePageUrl,
            bottomUiIcon: 'https://dpubstatic.udache.com/static/dpubimg/cXjI97vdBvqFvACBUqPHk.png',
            trackParams: {
              dsi: this.query.dsi,
              source_id: this.query.source_id,
              ...commonParams,
            },
          },
        }
        console.log('======toApp===== ', xenv(), launchAppParams, guidePageUrl, appLink)
        launchApp(launchAppParams)
      },
      800,
      true
    ),
    // 覆盖mixin，放置自动领券逻辑触发
    getCoupon() {},
  },
})
</script>

<style lang="stylus" scoped>
  .warp
    min-height 100vh
    width 100vw
    padding-bottom 72rpx
    overflow hidden
    box-sizing: border-box;
    background-size 100vw auto
    background-repeat no-repeat
    line-height: normal;
    position relative
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
</style>

<script name="json">
const config = {
  "component": true,
  "usingComponents": {
    "red-packet-close": "../../components/wyc/red-packet-close.mpx",
    "res-banner": "../../components/common/res-banner.mpx",
    "error-view": "../../components/common/error-view.mpx?async=error-view",
  }
}
module.exports = config
</script>
